import Phaser from "phaser"
// @ts-ignore
let replayButton
export default class GameOverScene extends Phaser.Scene {

    constructor() {
        super('game-over-scene')
    }

    preload() {
        this.load.image('bg-gameover', 'images/bg_gameover.png')
        this.load.image('game-over-text', 'images/gameover.png')
        this.load.image('replay-button', 'images/replay.png')
    }

    create(){
        this.add.image(256, 250, 'bg-gameover')
        this.add.image(256, 250, 'game-over-text')

        this.replayButton = this.add.image(256, 370, 'replay-button').setInteractive().setScale(0.13)

        // ketika di klik, scene akan berpindah ke CoronaBusterScene
        this.replayButton.once('pointerup', () => {
            this.scene.start('ghost_buster_scene')
        }, this)
    }
}